import {NO_DATA_AVAILABLE} from 'src/constants';

const normalizePossibleValue = (possibleValue: string) =>
    possibleValue.replace(/^"+|"+$/g, '').trim().toLowerCase();

const NORMALIZED_NO_DATA_AVAILABLE = normalizePossibleValue(NO_DATA_AVAILABLE);

const isNoDataAvailableValue = (possibleValue: string) =>
    normalizePossibleValue(possibleValue) === NORMALIZED_NO_DATA_AVAILABLE;

export const excludeNoDataAvailableValues = (possibleValues?: string[]) =>
    possibleValues?.filter(value => !isNoDataAvailableValue(value)) ?? [];
